import React from 'react'
import FundraiserOrderConfirmation from '../../components/User/OrderConfirmation'

const OrderConfirmation = () => {
  return (
    <FundraiserOrderConfirmation />
  )
}

export default OrderConfirmation